<div class="row div-no-overflow">
    <img srcset="assets/images/conveyor_1_v1.gif" src="assets/images/conveyor_1_v1.gif" />
</div>